import { css } from 'styled-components'

const Theme = {
  token_hidden: true,
  body_background_color: '#cba5a2',
  title_font: 'Helvetica Neue Bold',
  title_padding_left: true,
  text_font: 'Helvetica Neue',
  logo_image_url: 'sacresartisans.png',
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  framed_background: '#cba5a2',
  button_border_width: 3,
  button_color: 'transparent',
  button_border_color: '#cba5a2',
  button_text_color: 'black',
  button_hover_color: '#cba5a2',
  button_hover_text_color: 'black',
  button_radius: 0,
  button_outlined_color: '#cba5a2',
  button_outlined_border_color: '#cba5a2',
  button_outlined_text_color: 'black',
  button_outlined_hover_color: 'transparent',
  button_outlined_hover_border_color: '#cba5a2',
  button_outlined_hover_text_color: 'black',
  custom_alternate_button: css`
  border-color: #cba5a2;`
}

export default Theme
